/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { StorageCategory } from "abreact/core/pagestate/StorageCategory";
const CATEGORY_IDENTIFIER_SEP = "_";
export function createPageStorageIdentity(storageCategory, identifier) {
  return {
    identifier: identifier,
    category: storageCategory,
    key: `${storageCategory}${CATEGORY_IDENTIFIER_SEP}${identifier}`
  };
}
export function createPageStorageIdentityFromKey(key) {
  const parts = key.split(CATEGORY_IDENTIFIER_SEP);
  return {
    identifier: parts[1],
    category: parts[0] === StorageCategory.PRIMARY.toString() ? StorageCategory.PRIMARY : StorageCategory.SECONDARY,
    key
  };
}
//# sourceMappingURL=IPageStateStorageIdentity.js.map
